import { render, staticRenderFns } from "./updateModel.vue?vue&type=template&id=e6e997c8&scoped=true"
import script from "./updateModel.vue?vue&type=script&lang=js"
export * from "./updateModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e997c8",
  null
  
)

export default component.exports